<template>
  <div
    class="pure-text"
    :style="{
      'fontSize': `${config.fontSize}px`,
      'fontWeight': config.weight,
      'color': config.pureColor,
      'justifyContent': config.textAlign,
      'background': config.background
    }"
  >
    <span :class="{ ellipse: config.isEllipse }">{{ config.value }}</span>
    <el-tooltip
      class="item"
      effect="dark"
      :content="config.titleContentInfo"
      placement="top-start"
      v-if="config.titleContentInfo&&config.titleContentInfo.length>0"
    >
      <i class="el-icon-info"></i>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: 'PureText',
  props: ['config']
}
</script>

<style lang="stylus" scoped>
.pure-text
  width 100%
  height 100%
  display flex
  align-items center
.ellipse
  overflow hidden
  white-space nowrap
  text-overflow ellipsis
</style>
